import React from "react"
import MenuListItem from "../../../../../ui/molecules/Menu/MenuList/MenuListItem"
import { SearchState } from "../../../types"
import { useAlgoliaSearchState } from "../../controller/state"
import { CategoriesTreeItem } from "../../controller/state/categories"
import CheckboxFilterItem from "../CheckboxFilterItem"

interface Props {
  items: CategoriesTreeItem[]
  onOptionToggle: (option: CategoriesTreeItem) => void
  onOptionExpand: (option: CategoriesTreeItem) => void
}

const isSelected = (option: CategoriesTreeItem, state: SearchState) =>
  state.categoryCodes?.includes(option.code) ?? false

const getSelectedChildren = (
  option: CategoriesTreeItem
): CategoriesTreeItem[] => {
  const items = []
  if (option.checked) {
    items.push(option)
  }
  for (const child of option.children ?? []) {
    items.push(...getSelectedChildren(child))
  }
  return items
}

const ProductCategoryLevel = ({
  items,
  onOptionToggle,
  onOptionExpand,
}: Props) => {
  const { searchParams } = useAlgoliaSearchState()
  return (
    <>
      {items
        .filter((x) => x.enabled)
        .map((option) => (
          <div key={option.code}>
            {option.children.length > 0 ? (
              <MenuListItem
                item={{
                  content: option.label,
                  subtitle: getSelectedChildren(option)
                    .map((x) => x.label)
                    .join(", "),
                  onItemClick: () => onOptionExpand(option),
                }}
                bottomBorder
                center={false}
                px={2}
              />
            ) : (
              <div className="px-3">
                <CheckboxFilterItem
                  label={option.label}
                  count={option.count}
                  selected={isSelected(option, searchParams)}
                  onClick={() => onOptionToggle(option)}
                />
              </div>
            )}
          </div>
        ))}
    </>
  )
}

export default ProductCategoryLevel
